import React from "react";
import HomePage from "@templates/homePage";
import { ReferralModalCustomer } from "@components/shared/referralModal";

export default function HomepageDefault() {
  return (
    <>
      <ReferralModalCustomer />
      <HomePage />
    </>
  );
}

export { Head } from "@templates/homePage";
